import type {QueryParams} from '@jetbrains/teamcity-ui/dist/utils'

import type {AppThunk} from '../../../../../../actions/types'
import type {LoadedEndpoints} from '../../../../../../routes/loadEndpoint'
import type {BuildId} from '../../../../../../types'
import {toBuildId} from '../../../../../../types'
import {preloadBuildTabs} from '../../../../BuildPage/BuildTabs/BuildTabs.preload'

import {preloadJobDetails} from './JobDetails/JobDetails.preload'

export const preloadDetails =
  (runId: BuildId, queryParams: QueryParams): AppThunk<LoadedEndpoints> =>
  dispatch => {
    const {job, tab} = queryParams
    return [
      ...(job != null
        ? dispatch(preloadJobDetails(queryParams))
        : dispatch(preloadBuildTabs(toBuildId(runId), tab, queryParams, true))),
    ]
  }
